<template>
  <div class="applyResult w1200">
    <div class="tipsBox">
      <img src="@/assets/images/finishIcon.png" class="finishIcon" />
      <h3>购买成功</h3>
      <p><i v-if="ticketInfo.review_type == 1">（需审核）</i>审核将在活动开始前完成，请耐心等待！</p>
      <div class="backDetail">
        <a-button @click="backActivity">返回活动</a-button>
        <a-button type="primary" @click="goActivityDetail">查看订单</a-button>
      </div>
    </div>
    <!-- 购票信息 -->
    <div class="ticketInfo">
      <div class="listItem">
        <span class="label">订单编号</span>
        <span class="content">{{ ticketInfo.order_no }}</span>
      </div>
      <div class="listItem">
        <span class="label">活动名称</span>
        <span class="content">{{ ticketInfo.title }}</span>
      </div>
      <div class="listItem">
        <span class="label">活动时间</span>
        <span class="content">{{ ticketInfo.time }}</span>
      </div>
      <div class="listItem">
        <span class="label">活动地点</span>
        <span class="content">{{ ticketInfo.site }}</span>
      </div>
      <div class="listItem">
        <span class="label">活动票种</span>
        <span class="content">{{ ticketInfo.ticket_title }}</span>
      </div>
      <div class="listItem">
        <span class="label">购买数量</span>
        <span class="content">{{ ticketInfo.num }}</span>
      </div>
      <div class="listItem">
        <span class="label">购票单价</span>
        <span class="content red" style="font-weight: bold">￥{{ ticketInfo.price }}</span>
      </div>
      <h3>其他信息</h3>
      <div class="nameBox">
        <div v-for="item in ticketInfo.user" :key="item.index" style="margin-bottom: 16px">
          <span class="label other">{{ item.name }}</span>
          <span>
            <i>{{ item.phone }}</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyResult',
  props: ['orderId'],
  data() {
    return {
      ticketInfo: {},
    }
  },
  mounted() {
    this.getTickerResult()
  },
  methods: {
    async getTickerResult() {
      const { data: res } = await this.$http.post('/offline/order_offline', {
        _id: this.orderId,
      })
      this.ticketInfo = res.data
      console.log(this.ticketInfo)
    },
    backActivity() {
      let routeData = this.$router.push({
        name: 'OffLineDetails',
        query: {
          id: this.ticketInfo.id,
        },
      })
      // window.open(routeData.href, '_blank')
    },
    goActivityDetail() {
      let routeData = this.$router.push({
        name: 'ActiveOrderDetails',
        query: {
          id: this.ticketInfo.order_no,
        },
      })
      // this.$router.resolve
      // window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
.applyResult {
  background-color: #fff;
  padding: 40px 0;
}
.resultBox {
  height: 100%;
  background-color: #fff;
  padding: 40px;
}
.tipsBox {
  text-align: center;

  .finishIcon {
    width: 60px;
    height: 60px;
  }
  h3 {
    font-size: 22px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin: 16px 0;
  }
  p {
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 32px;
  }
  p i {
    color: #ffbb52;
  }
  .backDetail {
    margin-bottom: 32px;
    .ant-btn {
      margin: 0 16px;
    }
  }
}
.ticketInfo {
  width: 860px;
  min-height: 400px;
  background-color: #f1f1f1;
  margin: 0 auto;
  padding: 32px;
  margin-bottom: 40px;

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin: 32px 0 16px;
  }
  .listItem {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .listItem:last-child {
    margin-bottom: 0;
  }
  .listItem .label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-right: 16px;
  }
  .nameBox {
    font-size: 14px;
  }
  .label.other {
    color: rgba(0, 0, 0, 0.85);
    margin-right: 40px;
  }
  .content {
    max-width: 80%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
  .listItem .content i {
    margin-right: 16px;
  }
}
.red {
  color: #ff4d4f !important;
}
</style>
